import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

// The sign-in pass lasts 2 hours. When it runs out, quietly renew it (up to 7 days) and retry, so long editing sessions don't fail with "Not authenticated".
let renewing = null;
let onSignedOut = () => {};
export const setSignedOutHandler = (fn) => { onSignedOut = fn; };
const SKIP = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/forgot-password", "/auth/reset-password"];
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status !== 401 || !cfg || cfg._retried || SKIP.some((p) => cfg.url?.startsWith(p))) throw error;
  cfg._retried = true;
  renewing = renewing || api.post("/auth/refresh").finally(() => { renewing = null; });
  try {
    await renewing;
  } catch {
    if (cfg.url !== "/auth/me") onSignedOut();
    throw error;
  }
  return api(cfg);
});

export const fileUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u || "");

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}
